// export const baseUrl = 'https://ddektitdlncgg.cloudfront.net/myswapapi-cl'

function getChartsNetwork() {
    return window.localStorage.getItem('charts_network') || 'mainnet'
}

export const BUCKET = getChartsNetwork().includes('mainnet') ? 'myswap-cl-charts' : 'myswap-cl-charts-staging'
const bucketURl = `https://${BUCKET}.s3.amazonaws.com`
const baseUrl = `${bucketURl}/myswapapi-cl` // 'https://myswap-charts.s3.amazonaws.com/myswapapi-cl'
export const volumeUrl = `${bucketURl}/myswapapi-cl`
// export const volumeUrl = 'https://ddektitdlncgg.cloudfront.net/drop_cl'

// we use this to fetch the TVL and volume data per pool before waiting for the pools metadata response.
// so when a new pool is added, we should add it's id here, otherwise we won't fetch it's data
export const EXPECTED_POOLS = [
    '0x35335db8ab0e033e0cd9fca2478b38cfd6cb6dfa24a37f3f65a66e402da0b2e',
    '0x53eeeef77082cf403f77e79411651234bd4346be100d0d42540e7055f343c2',
    '0x6466c43edbe6b3c35b5048efab935d946f2192ed55d9f89cd911eb88a867fb2',
    '0x5d0d9be14c0c4041857ec9b079b3ceac7a2046ca9f28bf4aa79f92af55e7764'
]

export type TVLDatAPoint = {
    timestamp: number
    total_amount_sum: number
}

const tvlEndpoint = `https://${BUCKET}.s3.us-east-1.amazonaws.com/myswapapi-cl/tvl.json`
// export const EXPECTED_POOLS = [1, 2, 3, 4, 5, 6, 7, 8, '0x35335db8ab0e033e0cd9fca2478b38cfd6cb6dfa24a37f3f65a66e402da0b2e', '0x53eeeef77082cf403f77e79411651234bd4346be100d0d42540e7055f343c2', '0x6466c43edbe6b3c35b5048efab935d946f2192ed55d9f89cd911eb88a867fb2', '0x5d0d9be14c0c4041857ec9b079b3ceac7a2046ca9f28bf4aa79f92af55e7764']
export const EXPECTED_POOLS_NEW = [`"0x35335db8ab0e033e0cd9fca2478b38cfd6cb6dfa24a37f3f65a66e402da0b2e"`]

export type PoolRawData = {
    poolkey: number | string
    poolId: number | string
    tvl: TvlResponse
    volume: VolumeResponse
    apr: APRResponse
}

export async function fetchTVLChartData() {
    const response = await fetch(tvlEndpoint).then<{ data: TVLDatAPoint[] }>(toJson)
    return response.data
}

export async function fetchRangeDataForPool(poolId: string) {
    // https://myswap-cl-charts.s3.amazonaws.com/data/pools/0x6466c43edbe6b3c35b5048efab935d946f2192ed55d9f89cd911eb88a867fb2/liqmap.json.gz
    const response = await fetch(`${backendUrl}/pools/${poolId}/liqmap.json.gz`).then<RangeResponse>(toJson) // dist_liquidity

    return response
}

// https://myswap-cl-charts.s3.amazonaws.com/data/0x6f15ec4b6ff0b7f7a216c4b2ccdefc96cbf114d6242292ca82971592f62273b/overview.json
const backendUrl = `https://${BUCKET}.s3.amazonaws.com/data`
type Characaristic = 'verified' | 'unknown' | 'failed'
export type TokenOverview = {
    is_bluechip: boolean
    is_code_verified: Characaristic
    is_initial_liquidity_timelock: Characaristic
    is_none_upgradable: Characaristic
    is_not_taxed: Characaristic
    price: number
    volume: number
    tvl: number
    volume_7d: number
    volume_24h: number
    volume_change_7d: number
    price_change_24h: string
    volume_change_24h: string
    tvl_change_24h: string
    tvl_change_7d: string
}

export type PoolOverview = {
    price: number
    volume: number
    tvl: number
    volume_7d: number
    volume_24h: number
    volume_change_7d: number
    fee: number
    price_change_24h: string
    volume_change_24h: string
    tvl_change_24h: string
    tvl_change_7d: string
    token0: string
    token1: string
    apr: {
        apr: number
        apr_cl: number
        percentage: number
        incentive_apr: number
    }
}

export async function loadTokenOverviewData(tokenAddress: string): Promise<TokenOverview | undefined> {
    try {
        const response: TokenOverview = await (await fetch(`${backendUrl}/tokens/${tokenAddress}/overview.json`)).json()
        return response
    } catch (e) {
        return undefined
    }
}

export async function loadPoolOverviewData(poolAddresss: string): Promise<PoolOverview | undefined> {
    try {
        const response: PoolOverview = await (await fetch(`${backendUrl}/pools/${poolAddresss}/overview.json`)).json()
        return response
    } catch (e) {
        return undefined
    }
}

export type TokenChartData = {
    timestamp: number
    volume?: number
}

export type TotalTVL = {
    timestamp: number
    tvl: number
}

export type TotalVolume = {
    timestamp: number
    volume: number
}

export type TotalChartsOverview = {
    volume_24h: number
    volume_change_24h: number
    volume_7d: number
    volume_change_7d: number
    tvl_change_24h: number
    tvl_change_7d: number
}

export async function fetchTotalOverview(): Promise<TotalChartsOverview> {
    const response: TotalChartsOverview = await (await fetch(`${backendUrl}/total_overview.json`)).json()
    return response
}

export async function loadChartsTotalTVL() {
    try {
        const response: TotalTVL[] = await (await fetch(`${backendUrl}/total_tvl.json`)).json()
        return response
    } catch (e) {
        return undefined
    }
}

export async function loadChartsTotalVolume() {
    try {
        const response: TotalVolume[] = await (await fetch(`${backendUrl}/total_volume.json`)).json()
        return response
    } catch (e) {
        return undefined
    }
}

export async function loadTokenChartData(
    type: 'volume' | 'tvl' | 'price' | 'liquidity',
    tokenAddress: string,
    endpoint?: 'tokens' | 'pools'
): Promise<TokenChartData[] | undefined> {
    if (type === 'liquidity') return
    const backendEndPoint = endpoint ? endpoint : 'tokens'
    try {
        const response: TokenChartData[] = await (await fetch(`${backendUrl}/${backendEndPoint}/${tokenAddress}/${type}.json`)).json()
        return response
    } catch (e) {
        return undefined
    }
}

export type PoolData = {
    poolkey: string
    token0: { symbol: string; address: string }
    token1: { symbol: string; address: string }
    pool_fee: number
}
export async function loadPoolsData(network?: string): Promise<PoolData[]> {
    if (!network) {
        const pools = await (await fetch(`${backendUrl}/pools/all.json`)).json()
        return pools.pools
    } else {
        const newBucket = network.includes('mainnet') ? 'myswap-cl-charts' : 'myswap-cl-charts-staging'
        const backendUrl2 = `https://${newBucket}.s3.amazonaws.com/data`
        const pools = await (await fetch(`${backendUrl2}/pools/all.json`)).json()
        return pools.pools
    }
}

export async function fetchData(): Promise<{
    poolsMetadata: PoolsMetadataResponse
    poolsRawData: Array<PoolRawData>
}> {
    const pools = await (await fetch(`${bucketURl}/myswapapi-cl-new.json`)).json()
    const poolIds = pools.pools.map((pool: any) => pool.poolkey)
    const [...poolsRawData] = await Promise.all([
        ...poolIds.map(async (poolId: number | string) => {
            try {
                const [tvl, volume, apr] = await Promise.all([
                    fetch(`${baseUrl}/pool/${poolId}/tvl.json`)
                        .then((response) => response.text())
                        .then<TvlResponse>((text) => {
                            // Replace 'NaN' with '0' in the response text
                            const sanitizedText = text.replace(/NaN/g, '0')
                            // Parse the sanitized text as JSON
                            return JSON.parse(sanitizedText)
                        }),
                    fetch(`${volumeUrl}/pool/${poolId}/volume.json`).then<VolumeResponse>(toJson),
                    fetch(`${volumeUrl}/pool/${poolId}/apr.json`)
                        .then((response) => response.text())
                        .then<APRResponse>((text) => {
                            // Replace 'NaN' with '0' in the response text
                            const sanitizedText = text.replace(/NaN/g, '0').replace(/Infinity/g, '0')
                            // Parse the sanitized text as JSON
                            return JSON.parse(sanitizedText)
                        })
                ])

                return { poolId, tvl, volume, apr } as PoolRawData
            } catch (e) {
                console.error(e)
                return {}
            }
        })
    ])
    const poolsData = pools.pools as { token0: { address: string; symbol: string }; token1: { address: string; symbol: string } }[]
    poolsData.map((pool) => {
        pool.token0.symbol = pool.token0.symbol.toUpperCase()
        pool.token1.symbol = pool.token1.symbol.toUpperCase()
        return pool
    })

    return { poolsMetadata: pools, poolsRawData }
}

const toJson = (res: any) => res.json()

export type PoolsMetadataResponse = {
    pools: Array<PoolMetadata>
}

export type PoolToken = { symbol: string; address: string }

export type PoolMetadata = {
    pool_fee: number
    poolkey: number | string
    id: number | string
    name: string
    token0: PoolToken
    token1: PoolToken
    tokenA: PoolToken
    tokenB: PoolToken
}

export type TvlResponse = {
    data: Array<{
        timestamp: number
        token_a_tvl: string
        token_b_tvl: string

        price_a_in_b: string
        price_b_in_a: string

        token_a_tvl_usd: string | null
        token_b_tvl_usd: string | null
    }>
}

export type RangeResponse = {
    data: Array<{
        tick: number
        liq: number
    }>
}

export type APRResponse = {
    data: Array<{
        apr: number
        apr_cl: number
        ratio: number
        percentage: number
    }>
}
export type VolumeResponse = {
    data: Array<{
        timestamp: number
        volume: { [token_symbol: string]: string }
        volume_usd: { [token_symbol: string]: { usd: string; native: string } }
    }>
}
